const modalHub = function (selector) {
  let modal = document.querySelector(selector);
  if (!modal) return;
  let closeBtn = modal ? modal.querySelector(".compare-modal__close") : null;
  let overlay = modal ? modal.querySelector(".compare-modal__overlay") : null;
  const triggerSelector = modal.dataset.triggers.split(",");
  let triggers = document.querySelectorAll(triggerSelector);

  let isOpen = false;

  function openModal() {
    if (!modal) return;

    modal.classList.add("is-active");
    document.body.style.overflow = "hidden";
    isOpen = true;
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove("is-active");
    document.body.style.overflow = "";
    isOpen = false;
  }

  /**
   * Unified event binding for all modal closing mechanisms:
   * - Close button
   * - Overlay click
   * - ESC key
   * - Background click
   */
  function bindCloseEvents() {
    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    if (overlay) {
      overlay.addEventListener("click", closeModal);
    }

    document.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) {
        closeModal();
      }
    });
  }

  function bindTriggers() {
    triggers = document.querySelectorAll(triggerSelector);

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", function (e) {
        const btn = e.currentTarget;

        // Custom rule: do not open if button has active compare state
        if (
          btn.classList.contains("dcaw-compare-btn") &&
          btn.classList.contains("is-active")
        ) {
          return;
        }

        e.preventDefault();
        openModal();
      });
    });
  }

  return {
    init: function () {
      if (!modal) return;
      bindCloseEvents();
      bindTriggers();
    },
  };
};

export default modalHub;
